import {useTranslation} from '@/translations/i18n'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {MedicalReportSectionTitle} from '../medical-report-section-title/MedicalReportSectionTitle'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ObjectKeys} from '@/utilities/helpers'
import {CARE_NETWORK_SWITCHES} from '../../utils'
import {CareNetworkSwitchField} from '../care-network-switch-field/CareNetworkSwitchField'

export const CareNetworkSections = () => {
    const {t} = useTranslation()

    return (
        <>
            <MedicalReportSectionTitle>{t('medical_records:care_network')}</MedicalReportSectionTitle>
            <FormSection title={t('commons:details')}>
                <Flexbox direction="column" gap={3} fullWidth>
                    {ObjectKeys(CARE_NETWORK_SWITCHES).map(field => (
                        <CareNetworkSwitchField key={field} field={field} />
                    ))}
                </Flexbox>
            </FormSection>
        </>
    )
}
